module.exports = __webpack_public_path__ + "img/Group 3123.bf73d253.png";